import { post } from "../utils/BackendClientLegacy";

export async function validateUserLogin() {
  const username = localStorage.getItem("username");
  const passwordHash = localStorage.getItem("passwordHash");

  if (!username || !passwordHash) {
    return false;
  }

  const response = await post("user/verify", {
    username,
    passwordHash,
  });

  if (response.status === 200) {
    const key = await response.text();
    localStorage.setItem("apiKey", key);
    localStorage.setItem("userLastVerified", new Date().toString());
  }

  return response.status === 200;
}
